import React from 'react';
import './wallpaper.css';

const wallpaper = () => {
    return (
        <div className="area">

             <ul className="circles">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul> 
        </div>



    )

};

export default wallpaper